export enum EMIT {
  SAVE = 'save',
  CANCEL = 'cancel',
  CLOSE = 'close',
  BACK = 'back',
  NEXT = 'next',
  UPDATE = 'update',
  TAB = 'tab',
  REMOVE = 'remove',
  SUCCESS = 'success',
  ACCEPT = 'accept',
  RESET = 'reset',
  UPDATE_DAY = 'updateDay',
  UPDATE_NOTE = 'updateNote',
  TOAST = 'toast',
  FILE_DROPPED = 'fileDropped',
  DOCUMENT_EVENT = 'documentEvent',
  EDIT_EVENT = 'editEvent',
  EDIT = 'edit',
  SAVE_NEW_EVENT = 'saveNewEvent',
  SAVE_EVENT_FAILED = 'saveEventFailed',
  DAY_VIEW = 'dayView',
  NEW_EVENT = 'newEvent',
  SAVE_DOCUMENT_EVENT = 'saveDocumentEvent',
  SHOULD_SAVE_GOALS = 'shouldSaveGoals',
  CLOSE_MODAL = 'closeModal',
  SHOW_MODAL = 'ShowModal',
  ADD_ITEMS = 'addItems',
  INCREMENT = 'increment',
  LOAD_MORE_ITEMS = 'loadMoreItems',
  DECREMENT = 'decrement',
  MAX = 'max',
  MOUNTED = 'mounted',
  NEW_GOAL = 'newGoal',
  ERROR = 'error',
  ENABLE = 'enable',
  DISABLE = 'disable',
  TRANSFER = 'transfer',
  ARCHIVED = 'archived',
  REMOVE_ROW = 'removeRow',
  UPDATE_GOAL_DATA = 'updateGoalData',
  UNAUTHORIZED = 'unauthorized',
  BLUR = 'blur',
  CHANGE = 'change',
  ADD = 'add',
  OK = 'ok',
  QUERY_PARAMS = 'define-query-params',
  SYNC = 'sync',
  MESSAGE_SENT = 'message-sent',
  SEND_MESSAGE_FILE = 'send-message-file',
  DELETE_MESSAGE = 'delete-message',
  DELETE_MESSAGE_FILE = 'delete-message-file',
  SHOW_PREVIEW = 'show-preview',
  DISCARD = 'discard',
  PLAY = 'play',
  PAUSE = 'pause',
  STOP = 'stop',
  ATTACH = 'attach',
  DETACH = 'detach',
  UPDATE_MODEL_VALUE = 'update:modelValue',
  DONE = 'done',
}
